var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllStock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1152,
    zoomAndPan: "magnify",
    viewBox: "0 0 864 863.999991",
    height: 1152,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "42c9354130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.414062 307.742188 L 558.53125 307.742188 L 558.53125 543.300781 L 30.414062 543.300781 Z M 30.414062 307.742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7eaa9a2f0c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 192 L 404 192 L 404 535 L 25 535 Z M 25 192 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b2f12371b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.449219 534.515625 L 25.15625 319.988281 L 305.949219 192.648438 L 403.238281 407.175781 Z M 122.449219 534.515625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "656b1cfde6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 191 307 L 570 307 L 570 650 L 191 650 Z M 191 307 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "717992ada6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 288.726562 649.609375 L 191.433594 435.082031 L 472.226562 307.738281 L 569.515625 522.265625 Z M 288.726562 649.609375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7b8e259531"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19 322 L 394 322 L 394 657 L 19 657 Z M 19 322 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "488cd1f24e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.433594 540.183594 L 108.511719 322.117188 L 393.933594 438.707031 L 304.855469 656.773438 Z M 19.433594 540.183594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e73690cdfe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 193 192 L 568 192 L 568 528 L 193 528 Z M 193 192 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "388219a53c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 193.230469 410.714844 L 282.308594 192.648438 L 567.730469 309.242188 L 478.652344 527.308594 Z M 193.230469 410.714844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "27126bd729"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.433594 190 L 569.761719 190 L 569.761719 662 L 19.433594 662 Z M 19.433594 190 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2af157cf6b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 305.460938 423.730469 L 833.574219 423.730469 L 833.574219 659.289062 L 305.460938 659.289062 Z M 305.460938 423.730469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3c7b4b3ae2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 300 308 L 679 308 L 679 651 L 300 651 Z M 300 308 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9f609b9fe7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 397.492188 650.507812 L 300.199219 435.980469 L 580.992188 308.636719 L 678.285156 523.164062 Z M 397.492188 650.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7283cf23fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 466 423 L 845 423 L 845 766 L 466 766 Z M 466 423 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4d2f16343d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 563.769531 765.601562 L 466.476562 551.070312 L 747.269531 423.730469 L 844.558594 638.257812 Z M 563.769531 765.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e26228d297"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 294 438 L 669 438 L 669 773 L 294 773 Z M 294 438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "609db623a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 294.476562 656.175781 L 383.554688 438.109375 L 668.976562 554.699219 L 579.898438 772.765625 Z M 294.476562 656.175781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "99ea223133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 468 308 L 843 308 L 843 644 L 468 644 Z M 468 308 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7f42c3eb03"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 468.273438 526.707031 L 557.351562 308.640625 L 842.773438 425.230469 L 753.695312 643.296875 Z M 468.273438 526.707031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "358106f2c1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 294.476562 306 L 844.804688 306 L 844.804688 778 L 294.476562 778 Z M 294.476562 306 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a3ac6a7211"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 176.027344 132.507812 L 704.144531 132.507812 L 704.144531 368.066406 L 176.027344 368.066406 Z M 176.027344 132.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee821d083d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 170 17 L 549 17 L 549 360 L 170 360 Z M 170 17 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7beef97671"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 268.058594 359.285156 L 170.769531 144.757812 L 451.558594 17.414062 L 548.851562 231.941406 Z M 268.058594 359.285156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "870ee458ef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 337 132 L 716 132 L 716 475 L 337 475 Z M 337 132 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "06c382c8a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 434.335938 474.375 L 337.046875 259.847656 L 617.835938 132.507812 L 715.128906 347.035156 Z M 434.335938 474.375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 5577605105
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 165 146 L 540 146 L 540 482 L 165 482 Z M 165 146 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2623851c14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 165.046875 364.953125 L 254.121094 146.882812 L 539.546875 263.476562 L 450.46875 481.542969 Z M 165.046875 364.953125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7c69f5e0f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 338 17 L 714 17 L 714 353 L 338 353 Z M 338 17 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "62c8fd72d7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 338.84375 235.484375 L 427.917969 17.417969 L 713.34375 134.007812 L 624.265625 352.074219 Z M 338.84375 235.484375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4c17dfd63a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 165.046875 14.21875 L 715.371094 14.21875 L 715.371094 486.949219 L 165.046875 486.949219 Z M 165.046875 14.21875 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -86.4,
    width: 1036.8,
    fill: "#ffffff",
    y: -86.399999,
    height: 1036.79999,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -86.4,
    width: 1036.8,
    fill: "#ffffff",
    y: -86.399999,
    height: 1036.79999,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#42c9354130)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 30.414062 543.300781 L 30.414062 307.742188 L 558.582031 307.742188 L 558.582031 543.300781 Z M 30.414062 543.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7eaa9a2f0c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b2f12371b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 122.449219 534.515625 L 25.15625 319.988281 L 305.886719 192.675781 L 403.179688 407.203125 Z M 122.449219 534.515625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#656b1cfde6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#717992ada6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 288.726562 649.609375 L 191.433594 435.082031 L 472.164062 307.765625 L 569.457031 522.292969 Z M 288.726562 649.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7b8e259531)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#488cd1f24e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 19.433594 540.183594 L 108.511719 322.117188 L 393.871094 438.683594 L 304.792969 656.75 Z M 19.433594 540.183594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e73690cdfe)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#388219a53c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 193.230469 410.714844 L 282.308594 192.648438 L 567.667969 309.214844 L 478.589844 527.28125 Z M 193.230469 410.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#27126bd729)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111931",
    d: "M 568.417969 302.765625 C 568.050781 302.125 567.683594 301.484375 567.132812 300.84375 C 566.949219 300.660156 566.765625 300.382812 566.492188 300.199219 C 565.851562 299.558594 565.023438 299.007812 564.199219 298.640625 C 564.109375 298.550781 563.925781 298.457031 563.832031 298.457031 C 563.832031 298.367188 563.742188 298.367188 563.742188 298.367188 L 297.960938 190.734375 C 295.578125 189.816406 293.007812 189.910156 290.71875 190.917969 L 24.84375 310.011719 C 23.925781 310.46875 23.101562 311.019531 22.367188 311.75 C 22.1875 311.933594 22.003906 312.210938 21.820312 312.394531 C 21.269531 313.035156 20.902344 313.675781 20.535156 314.320312 C 20.351562 314.6875 20.261719 314.960938 20.078125 315.234375 C 19.800781 316.152344 19.527344 317.070312 19.527344 318.078125 C 19.527344 318.167969 19.433594 318.261719 19.433594 318.351562 L 19.433594 544.988281 C 19.433594 547.460938 20.445312 549.84375 22.1875 551.585938 C 23.011719 552.414062 24.019531 553.054688 25.210938 553.605469 L 290.351562 660.777344 C 291.632812 661.421875 293.007812 661.878906 294.476562 661.878906 C 295.851562 661.878906 297.136719 661.511719 298.328125 660.960938 L 564.109375 542.054688 C 567.589844 540.496094 569.609375 537.011719 569.515625 533.34375 L 569.515625 306.710938 C 569.425781 305.609375 569.242188 304.601562 568.875 303.59375 C 568.691406 303.316406 568.601562 303.042969 568.417969 302.765625 Z M 294.660156 209.253906 L 338.757812 227.132812 L 102.132812 338.246094 L 51.980469 317.984375 Z M 285.308594 638.957031 L 37.769531 538.84375 L 37.769531 332.011719 L 93.238281 354.382812 L 93.238281 490.621094 C 93.238281 494.105469 95.164062 497.3125 98.28125 498.871094 L 184.917969 541.960938 C 186.292969 542.601562 187.667969 542.878906 189.042969 542.878906 C 190.695312 542.878906 192.4375 542.417969 193.902344 541.503906 C 196.5625 539.851562 198.210938 536.917969 198.210938 533.710938 L 198.121094 396.832031 L 285.308594 432.128906 Z M 294.292969 415.992188 L 211.503906 382.527344 L 443.546875 269.488281 L 536.96875 307.351562 Z M 551.179688 527.75 L 303.644531 638.5 L 303.644531 431.945312 L 551.179688 321.011719 Z M 551.179688 527.75 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2af157cf6b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 305.460938 659.289062 L 305.460938 423.730469 L 833.625 423.730469 L 833.625 659.289062 Z M 305.460938 659.289062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3c7b4b3ae2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9f609b9fe7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 397.492188 650.507812 L 300.199219 435.980469 L 580.929688 308.664062 L 678.222656 523.191406 Z M 397.492188 650.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7283cf23fd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4d2f16343d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 563.769531 765.601562 L 466.476562 551.070312 L 747.207031 423.757812 L 844.5 638.285156 Z M 563.769531 765.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e26228d297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#609db623a4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 294.476562 656.175781 L 383.554688 438.109375 L 668.914062 554.671875 L 579.839844 772.742188 Z M 294.476562 656.175781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#99ea223133)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7f42c3eb03)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 468.273438 526.707031 L 557.351562 308.640625 L 842.710938 425.207031 L 753.636719 643.273438 Z M 468.273438 526.707031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#358106f2c1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111931",
    d: "M 843.460938 418.757812 C 843.09375 418.117188 842.726562 417.472656 842.175781 416.832031 C 841.992188 416.648438 841.8125 416.375 841.535156 416.191406 C 840.894531 415.550781 840.070312 415 839.242188 414.632812 C 839.152344 414.539062 838.96875 414.449219 838.875 414.449219 C 838.875 414.355469 838.785156 414.355469 838.785156 414.355469 L 573.003906 306.726562 C 570.621094 305.808594 568.054688 305.898438 565.761719 306.90625 L 299.886719 426 C 298.972656 426.460938 298.144531 427.007812 297.414062 427.742188 C 297.230469 427.925781 297.046875 428.199219 296.863281 428.382812 C 296.3125 429.027344 295.945312 429.667969 295.578125 430.308594 C 295.394531 430.675781 295.304688 430.953125 295.121094 431.226562 C 294.847656 432.144531 294.570312 433.058594 294.570312 434.070312 C 294.570312 434.160156 294.480469 434.253906 294.480469 434.34375 L 294.480469 660.976562 C 294.480469 663.453125 295.488281 665.835938 297.230469 667.578125 C 298.054688 668.402344 299.0625 669.046875 300.253906 669.59375 L 565.394531 776.769531 C 566.679688 777.410156 568.054688 777.871094 569.519531 777.871094 C 570.894531 777.871094 572.179688 777.503906 573.371094 776.953125 L 839.152344 658.042969 C 842.636719 656.484375 844.652344 653 844.5625 649.335938 L 844.5625 422.699219 C 844.46875 421.601562 844.285156 420.589844 843.917969 419.582031 C 843.734375 419.308594 843.644531 419.03125 843.460938 418.757812 Z M 569.703125 325.242188 L 613.800781 343.121094 L 377.175781 454.238281 L 327.027344 433.976562 Z M 560.351562 754.949219 L 312.816406 654.835938 L 312.816406 448.003906 L 368.28125 470.375 L 368.28125 606.609375 C 368.28125 610.09375 370.207031 613.304688 373.324219 614.863281 L 459.960938 657.953125 C 461.335938 658.59375 462.710938 658.867188 464.085938 658.867188 C 465.738281 658.867188 467.480469 658.410156 468.945312 657.492188 C 471.605469 655.84375 473.253906 652.910156 473.253906 649.699219 L 473.164062 512.820312 L 560.351562 548.117188 Z M 569.335938 531.984375 L 486.550781 498.519531 L 718.59375 385.476562 L 812.015625 423.34375 Z M 826.226562 643.742188 L 578.6875 754.492188 L 578.6875 547.9375 L 826.226562 437.003906 Z M 826.226562 643.742188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a3ac6a7211)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 176.027344 368.066406 L 176.027344 132.507812 L 704.195312 132.507812 L 704.195312 368.066406 Z M 176.027344 368.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee821d083d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7beef97671)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 268.058594 359.285156 L 170.769531 144.757812 L 451.5 17.441406 L 548.789062 231.96875 Z M 268.058594 359.285156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#870ee458ef)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#06c382c8a7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 434.335938 474.375 L 337.046875 259.847656 L 617.777344 132.535156 L 715.066406 347.0625 Z M 434.335938 474.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5577605105)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2623851c14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 165.046875 364.953125 L 254.121094 146.882812 L 539.484375 263.449219 L 450.40625 481.515625 Z M 165.046875 364.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7c69f5e0f1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#62c8fd72d7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 338.84375 235.484375 L 427.917969 17.417969 L 713.28125 133.984375 L 624.203125 352.050781 Z M 338.84375 235.484375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4c17dfd63a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111931",
    d: "M 714.027344 127.535156 C 713.660156 126.894531 713.296875 126.25 712.746094 125.609375 C 712.5625 125.425781 712.378906 125.152344 712.101562 124.96875 C 711.460938 124.328125 710.636719 123.777344 709.8125 123.410156 C 709.71875 123.316406 709.535156 123.226562 709.445312 123.226562 C 709.445312 123.132812 709.351562 123.132812 709.351562 123.132812 L 443.570312 15.5 C 441.1875 14.585938 438.621094 14.675781 436.328125 15.683594 L 170.457031 134.777344 C 169.539062 135.234375 168.714844 135.785156 167.980469 136.519531 C 167.796875 136.703125 167.613281 136.976562 167.429688 137.160156 C 166.878906 137.804688 166.511719 138.445312 166.148438 139.085938 C 165.964844 139.453125 165.871094 139.726562 165.6875 140.003906 C 165.414062 140.921875 165.136719 141.835938 165.136719 142.84375 C 165.136719 142.9375 165.046875 143.027344 165.046875 143.121094 L 165.046875 369.753906 C 165.046875 372.230469 166.054688 374.613281 167.796875 376.355469 C 168.621094 377.179688 169.628906 377.824219 170.824219 378.371094 L 435.960938 485.546875 C 437.246094 486.1875 438.621094 486.648438 440.085938 486.648438 C 441.460938 486.648438 442.746094 486.28125 443.9375 485.730469 L 709.71875 366.820312 C 713.203125 365.261719 715.21875 361.777344 715.128906 358.109375 L 715.128906 131.476562 C 715.035156 130.378906 714.855469 129.367188 714.488281 128.359375 C 714.304688 128.085938 714.210938 127.808594 714.027344 127.535156 Z M 440.269531 34.019531 L 484.371094 51.898438 L 247.742188 163.015625 L 197.59375 142.753906 Z M 430.917969 463.726562 L 183.382812 363.613281 L 183.382812 156.78125 L 238.847656 179.152344 L 238.847656 315.386719 C 238.847656 318.871094 240.773438 322.082031 243.890625 323.640625 L 330.53125 366.730469 C 331.90625 367.371094 333.28125 367.644531 334.65625 367.644531 C 336.304688 367.644531 338.046875 367.1875 339.515625 366.269531 C 342.171875 364.621094 343.824219 361.6875 343.824219 358.476562 L 343.730469 221.597656 L 430.917969 256.894531 Z M 439.90625 240.761719 L 357.117188 207.296875 L 589.160156 94.253906 L 682.582031 132.117188 Z M 696.792969 352.519531 L 449.253906 463.269531 L 449.253906 256.710938 L 696.792969 145.78125 Z M 696.792969 352.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllStock);
export default __webpack_public_path__ + "static/media/AllStock.3171097ccf676c0f56bbfaa309dfefe3.svg";
export { ForwardRef as ReactComponent };